
import ContactBanner from '@/components/organisms/layout/h-contact-banner.vue';
import LanguageSwitch from '@/components/molecules/language-switch/h-language-switch.vue';
import AppFooter from '@/components/organisms/layout/h-footer-compact';

export default {
  name: 'PropertyRadarSupport',
  components: { AppFooter, LanguageSwitch, ContactBanner },

  layout: 'blank',

  data: () => ({
    email: 'info@hypofriend.de',
  }),

  head() {
    return {
      title: this.$i18n.t('seo.title'),
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('seo.description'),
        },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        {
          hid: 'ogTitle',
          property: 'og:title',
          content: this.$i18n.t('seo.title'),
        },
        {
          hid: 'ogDescription',
          property: 'og:description',
          content: this.$i18n.t('seo.description'),
        },
      ],
      htmlAttrs: { lang: this.$i18n.locale },
    };
  },

  methods: {
    trackMailtoClick() {
      this.$eventTrackClick('Property Radar Support CTA');
    },
  },
};
